import * as React from 'react';
import { makeStyles, FormControl, FormLabel, FormGroup, FormControlLabel } from '@material-ui/core';
import TextStyles, { fontFamilies } from '../../../theme/text';
import { neutral } from '../../../theme/colors';
import { TertiaryButton, StyledCheckbox } from 'kagr-ui';

interface FilterGroupProps {
  /** array of possible filter options */
  options: {
    name: string;
    id: string;
  }[];
  /** display name of collection of filters */
  title: string;
  /** currently selected filter ids */
  selected: string[];
  updateSelectedFilters: (selected: string[]) => void;
}

const useStyles = makeStyles({
  formGroup: {
    alignItems: 'flex-start',
    '& MuiCheckbox-root': {
      padding: 0
    }
  },
  formLabel: {
    color: neutral[600],
    fontWeight: 500
  },
  inputLabel: {
    marginLeft: 0,
    '& .MuiFormControlLabel-label': {
      fontFamily: fontFamilies.heading,
      fontSize: 14,
      lineHeight: 1.25
    },
    '& .MuiIconButton-root': {
      padding: 4
    }
  },
  selectActions: {
    fontFamily: fontFamilies.heading,
    fontSize: 11,
    color: neutral[500],
    padding: '0 4px',
    '& p': {
      margin: 0
    }
  },
  selectAllNone: {
    height: 30
  },
  noFilters: {
    ...TextStyles.label1
  }
});

/**
 * Render a section of filter options in the fitler sidebar
 */
const OptionsFilterGroup = ({ options, title, selected, updateSelectedFilters }: FilterGroupProps) => {
  const classes = useStyles();

  const handleCheckToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!selected.includes(event.target.value)) {
      updateSelectedFilters([...selected, event.target.value]);
    } else {
      updateSelectedFilters(selected.filter(selection => selection != event.target.value));
    }
  };

  const selectAll = () => {
    updateSelectedFilters(options.map(option => option.id));
  };
  const selectNone = () => {
    updateSelectedFilters([]);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" className={classes.formLabel}>
        {title}
      </FormLabel>
      <FormGroup className={classes.formGroup}>
        <div className={classes.selectActions}>
          <p>
            Select:
            <TertiaryButton
              component="button"
              text="All"
              title="All"
              handleClick={selectAll}
              className={classes.selectAllNone}
            />
            |
            <TertiaryButton
              component="button"
              text="None"
              title="None"
              handleClick={selectNone}
              className={classes.selectAllNone}
            />
          </p>
        </div>
        {options.length ? (
          options.map(option => (
            <FormControlLabel
              key={`${option.name}-${option.id}`}
              control={
                <StyledCheckbox
                  checked={selected.includes(option.id)}
                  onChange={event => {
                    handleCheckToggle(event);
                  }}
                  name={option.name}
                  value={option.id}
                />
              }
              label={option.name}
              className={classes.inputLabel}
            />
          ))
        ) : (
          <p className={classes.noFilters}>No filters available</p>
        )}
      </FormGroup>
    </FormControl>
  );
};

export default OptionsFilterGroup;
